import { useState } from "react";
import {
  Box,
  IconButton,
  Popover,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OrderPopoverOptions = ({
  deleting,
  handleOpen,
  handleSuspend,
  handlePackages,
  handleDispatches,
  orderStatus,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const myHandleDelete = () => {
    setAnchorEl(null);
    handleSuspend();
  };

  const classes = {
    optionsBtn: {
      position: "absolute",
      top: 0,
      right: 5,
      ml: 5,
    },
    itemIcon: {
      minWidth: "fit-content",
      mr: 2,
    },
    itemText: {
      "& > span": {
        fontWeight: 500,
      },
    },
  };

  return (
    <>
      <IconButton
        disabled={deleting}
        sx={classes.optionsBtn}
        onClick={handleClick}
      >
        <Box component={FontAwesomeIcon} icon="ellipsis" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: -105,
        }}
      >
        <List sx={{ paddingX: 1.5 }}>
          <ListItemButton 
            onClick={handleOpen} 
            disabled={!handleOpen}
            sx={{
              '&.Mui-disabled': {
                opacity: 0.5,
                cursor: 'not-allowed'
              }
            }}
          >
            <ListItemIcon sx={classes.itemIcon}>
              <Box component={FontAwesomeIcon} icon="eye" />
            </ListItemIcon>
            <ListItemText sx={classes.itemText} primary="Ver orden" />
          </ListItemButton>
          <ListItemButton 
            onClick={handlePackages} 
            disabled={!handlePackages}
            sx={{
              '&.Mui-disabled': {
                opacity: 0.5,
                cursor: 'not-allowed'
              }
            }}
          >
            <ListItemIcon sx={classes.itemIcon}>
              <Box component={FontAwesomeIcon} icon="boxes-stacked" />
            </ListItemIcon>
            <ListItemText sx={classes.itemText} primary="Paquetes" />
          </ListItemButton>
          <ListItemButton 
            onClick={handleDispatches} 
            disabled={!handleDispatches}
            sx={{
              '&.Mui-disabled': {
                opacity: 0.5,
                cursor: 'not-allowed'
              }
            }}
          >
            <ListItemIcon sx={classes.itemIcon}>
              <Box component={FontAwesomeIcon} icon="truck-fast" />
            </ListItemIcon>
            <ListItemText sx={classes.itemText} primary="Despachos" />
          </ListItemButton>
          <ListItemButton 
            sx={{ 
              color: "error.main",
              '&.Mui-disabled': {
                opacity: 0.5,
                cursor: 'not-allowed',
                color: 'error.main'
              }
            }} 
            onClick={myHandleDelete}
            disabled={!handleSuspend || orderStatus === 3}
          >
            <ListItemIcon sx={classes.itemIcon}>
              <Box
                component={FontAwesomeIcon}
                icon="ban"
                sx={{ color: "error.main" }}
              />
            </ListItemIcon>
            <ListItemText sx={classes.itemText} primary="Suspender" />
          </ListItemButton>
        </List>
      </Popover>
    </>
  );
};

export default OrderPopoverOptions;
